import React from "react";
import Logo from "media/logo.png";
import { withRouter } from "react-router";
class Loader extends React.PureComponent {
  render = () => [
    <div
      style={{
        // filter: `blur(${this.state.loading ? 0 : 5}px)`,
        opacity: this.props.loading ? 1 : 0,
        zIndex: this.props.loading ? 999999999 : -1
      }}
      className="loader"
    >
      <img src={Logo} />
    </div>,

    !this.props.loading ? this.props.children : null
  ];
}
export default withRouter(Loader);
